import React, {useEffect} from "react";
import {Link} from "react-router-dom";
import {ArrowBackOutlined} from "@mui/icons-material";
import "./page.css";

const PageHeader = ({title, subtitle, actions, backTo, backLabel = "Назад", eyebrow, meta}) => {
    useEffect(() => {
        if (typeof title === "string" && title.trim()) {
            document.title = `${title} · iStudy Admin`;
        }
        return () => {
            document.title = "iStudy Admin";
        };
    }, [title]);

    return (
        <header className="ui-page-header">
            {backTo && (
                <Link to={backTo} className="ui-page-header__back">
                    <ArrowBackOutlined fontSize="small"/>
                    {backLabel}
                </Link>
            )}

            {eyebrow && <div className="ui-page-header__eyebrow">{eyebrow}</div>}

            <div className="ui-page-header__row">
                <div className="ui-page-header__titles">
                    <h1 className="ui-page-header__title">{title}</h1>
                    {subtitle && <p className="ui-page-header__subtitle">{subtitle}</p>}
                    {Array.isArray(meta) && meta.length > 0 && (
                        <div className="ui-page-header__meta">
                            {meta.map((item, index) => (
                                <span key={index} className="ui-page-header__meta-item">{item}</span>
                            ))}
                        </div>
                    )}
                </div>
                {actions && <div className="ui-page-header__actions">{actions}</div>}
            </div>
        </header>
    );
};

export default PageHeader;
